module.exports = __webpack_public_path__ + "media/icons/pencil-ba659eb9d02887efa098277fa00da8c3.svg";